import { useEffect, useState } from 'react'

const TICK_MS = 1000

interface StaleSnapshotClockInput {
    isStale: boolean
    errorUpdatedAt?: number
}

export function useStaleSnapshotClock({
    isStale,
    errorUpdatedAt = 0,
}: StaleSnapshotClockInput) {
    const [liveNow, setLiveNow] = useState(0)
    const [firstOutageAt, setFirstOutageAt] = useState<number | null>(null)
    const outageStartedAt = isStale
        ? (firstOutageAt ?? (errorUpdatedAt || Date.now()))
        : null

    useEffect(() => {
        if (isStale) {
            setFirstOutageAt((current) =>
                current === null ? errorUpdatedAt || Date.now() : current,
            )
            return
        }
        setFirstOutageAt(null)
    }, [errorUpdatedAt, isStale])

    useEffect(() => {
        if (isStale) return
        setLiveNow(Date.now())
        const interval = window.setInterval(
            () => setLiveNow(Date.now()),
            TICK_MS,
        )
        return () => window.clearInterval(interval)
    }, [isStale])

    return {
        nowMs: outageStartedAt ?? liveNow,
        outageStartedAt,
    }
}
